import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {PostPayloadInterface} from '../models/post-payload.interface';
import {Utilities} from "../utils/utilities";
import {BaseRepository} from "./base/base.repository";

@Injectable({
    providedIn: 'root'
})
export class OrderRepository extends BaseRepository {
    private readonly staffPath;
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.path = 'dashboard/admin/orders';
        this.staffPath = 'dashboard/staff/orders';
    }

    reAssocBillingData(billingDataId: number, id: number, pathPostFix: string) {
        const path = this.staffPath + '/' + id + '/re-assoc/' + pathPostFix + '/' + billingDataId;
        return super.patch(path);
    }


    orderSendNew(id: number) {
        const path = this.path + '/send-new/' + id;
        return super.get(path);
    }

    orderResend(id: number) {
        const path = this.path + '/resend/' + id;
        return super.get(path);
    }
    orderResendAndRegenerate(id: number) {
        const path = this.path + '/resend-and-regenerate/' + id;
        return super.get(path);
    }

    saveNewDelivery(payload: PostPayloadInterface) {
        const path = this.path + '/delivery-calendar';
        return super.post(path, payload);
    }

    saveNewDeliveryAsStaff(payload: PostPayloadInterface) {
        const path = this.staffPath + '/delivery-calendar';
        return super.post(path, payload);
    }

    saveAsStaff(payload: PostPayloadInterface) {
        const path = this.staffPath;
        return super.post(path, payload);
    }

}
